import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });

        // data-scroll-event-progress Example
        window.addEventListener('progressEvent', (e) => {
            const { target, progress } = e.detail;
            const percent = progress * 100;
            const percentRounded = Math.round(progress * 100);
            const progressEl = document.querySelector('.js-progress');
            const progressBarEl = document.querySelector('.js-progress-bar');

            if (progress && progressEl && progressBarEl) {
                progressEl.innerHTML = percentRounded + '%';
                progressBarEl.style.cssText += `width: ${percent}%;`;
            }
        });
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        window.removeEventListener('progressEvent', () => { });
    }
}
